/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "react-responsive-pagination";
import {
  formatDateDash,
  ITEM_PER_PAGE,
  setParams,
  messageSuccess,
  messageError,
  StatusCatalog,
} from "../../helper";
import "./app.scss";
import { IoIosLink } from "react-icons/io";
import { DELETE_CATALOG, QUERY_CATALOGS, UPDATE_CATALOG } from "./apollo";
import Notiflix from "notiflix";
import PreviewImage from "../../helper/previewImage";
import LimitData from "../../controllers/LimitData";
import EditCatalog from "./editCatalog";
import AddCatalog from "./addCatalog";
import { useLazyQuery, useMutation } from "@apollo/client/react";
export default function CatalogScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location?.search);
  const [currentPage, setCurrentPage] = useState(1);
  const [numberRows, setNumberRows] = useState(ITEM_PER_PAGE);
  const [newLoadData, setNewLoadData] = useState(false);

  const [catalogList, setDataCatalog] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [deleteCatalog] = useMutation(DELETE_CATALOG);
  const [updateCatalog] = useMutation(UPDATE_CATALOG);
  const [fetchCatalog, { data: catalogData }] = useLazyQuery(QUERY_CATALOGS, {
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    fetchCatalog({
      variables: {
        where: {
          fullSearch: searchValue ? String(searchValue) : undefined,
        },
        skip: numberRows * currentPage - numberRows,
        limit: numberRows,
      },
    });
  }, [newLoadData, currentPage, numberRows, fetchCatalog, searchValue]);

  useEffect(() => {
    setDataCatalog(catalogData?.catalogs?.data);
  }, [catalogData]);

  const totalItem = catalogData?.catalogs?.total;
  const totalPage = Math.ceil(totalItem / numberRows);

  const NO = (index) => {
    const no = numberRows * currentPage - numberRows;
    if (numberRows > 0) {
      return no + index + 1;
    } else {
      return index + 1;
    }
  };

  const _onChangeRows = (e) => {
    let _value = e?.target?.value;
    navigate({
      search: setParams(`rows`, _value),
    });
    setNumberRows(parseInt(_value));
  };

  useEffect(() => {
    let page = queryParams.get("page");
    let rows = queryParams.get("rows");

    if (page) {
      setCurrentPage(parseInt(page));
    } else {
      setCurrentPage(1);
    }
    if (rows) {
      setNumberRows(parseInt(rows));
    } else {
      setNumberRows(ITEM_PER_PAGE);
    }
  }, [queryParams]);

  //ລົບຂໍ້ມູນ
  const _handleDelete = (id) => {
    Notiflix.Confirm.show(
      "ແຈ້ງເຕືອນ",
      "ທ່ານຕ້ອງການລຶບຂໍ້ມູນ ນີ້ແທ້ ຫຼື ບໍ່?",
      "ຕົກລົງ",
      "ຍົກເລີກ",
      async () => {
        try {
          const _delete = await deleteCatalog({
            variables: {
              where: {
                id: parseInt(id),
              },
            },
          });
          if (_delete) {
            messageSuccess("ດຳເນີນການສຳເລັດ");
            setNewLoadData(!newLoadData);
          }
        } catch (error) {
          console.log(error);
          messageError("ດຳເນີນການບໍ່ສຳເລັດ");
        }
      },
      () => {
        return false;
      }
    );
  };
  const _handleUpdate = (id, status) => {
    let _status = status === 1 ? 0 : 1;
    let _text = status === 1 ? "ປິດ" : "ເປີດໃຊ້ງານ";
    Notiflix.Confirm.show(
      "ແຈ້ງເຕືອນ",
      `ທ່ານຕ້ອງການ${_text}ລາຍການນີ້ແທ້ ຫຼື ບໍ່?`,
      "ຕົກລົງ",
      "ຍົກເລີກ",
      async () => {
        try {
          const _updated = await updateCatalog({
            variables: {
              data: {
                isPublic: _status,
              },
              where: {
                id: parseInt(id),
              },
            },
          });
          if (_updated) {
            messageSuccess("ດຳເນີນການສຳເລັດ");
            setNewLoadData(!newLoadData);
          }
        } catch (error) {
          console.log(error);
          messageError("ດຳເນີນການບໍ່ສຳເລັດ");
        }
      },
      () => {
        return false;
      }
    );
  };

  return (
    <>
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div className="row">
          <div className="col-md-12" style={{ zIndex: 1 }}>
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <p className="mb-md-0 mb-2 d-flex align-items-center gap-2">
                    <AddCatalog
                      setNewLoad={(res) => setNewLoadData(!newLoadData)}
                    />
                  </p>
                  <div className="d-flex align-items-center flex-wrap">
                    <LimitData
                      numberRows={numberRows}
                      onChangeRows={_onChangeRows}
                      onSearch={(_onSearch) => {
                        setSearchValue(_onSearch);
                      }}
                      numberPage={currentPage}
                      total={totalItem}
                      hiddenSearch={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div id="cart" className="iq-product-tracker-card show b-0">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-responsive mb-0 table-sm rounded">
                        <thead>
                          <tr>
                            <th width={10}>ລຳດັບ</th>
                            <th className="text-nowrap">ໜ້າປົກ</th>
                            <th className="text-nowrap">ຫົວຂໍ້</th>
                            <th className="text-nowrap text-center">ປະເພດ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {catalogList?.map((item, index) => (
                            <>
                              <tr data-item="list" key={index}>
                                <td className="text-center">{NO(index)}</td>
                                <td
                                  scope="row"
                                  className="text-nowrap"
                                  width={100}
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <PreviewImage
                                      image={item?.coverImage}
                                      width={200}
                                      height={120}
                                    />
                                  </div>
                                </td>
                                <td>
                                  {" "}
                                  <div>
                                    <h3 className="fs-2 text-primary align-top">
                                      {item?.title ? item?.title : " "}
                                    </h3>

                                    <span className="text-muted">
                                      <IoIosLink size={20} />{" "}
                                      {item?.url
                                        ? item?.url
                                        : "-"}
                                    </span>
                                    <br />
                                    <span className="text-muted">
                                      <i className="icon-clock me-1" />{" "}
                                      {item?.createdAt
                                        ? formatDateDash(item?.createdAt)
                                        : "-"}
                                    </span>
                                    <hr />
                                    <EditCatalog
                                      item={item}
                                      onSuccess={() => {
                                        setNewLoadData(!newLoadData);
                                      }}
                                    />
                                    <button
                                      className="btn btn-icon  btn-danger rounded-circle"
                                      onClick={(e) => {
                                        _handleDelete(item?.id);
                                      }}
                                    >
                                      <i className="icon-trash fs-5" />
                                    </button>
                                    {item?.isPublic === 1 ? (
                                      <button
                                        onClick={() =>
                                          _handleUpdate(
                                            item?.id,
                                            item?.isPublic
                                          )
                                        }
                                        className="btn btn-icon btn-success ms-3 rounded-circle"
                                      >
                                        ເປີດ
                                      </button>
                                    ) : (
                                      <button
                                        onClick={() =>
                                          _handleUpdate(
                                            item?.id,
                                            item?.isPublic
                                          )
                                        }
                                        className="btn btn-icon btn-danger ms-3 rounded-circle"
                                      >
                                        ປິດ
                                      </button>
                                    )}
                                  </div>
                                </td>
                                <td className="text-center">{item?.type ? StatusCatalog(item?.type) : " "}</td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer">
                      {(() => {
                        return (
                          <Pagination
                            total={totalPage}
                            current={currentPage || 1}
                            onPageChange={(page) => {
                              navigate({
                                search: setParams("page", page.toString()),
                              });
                              setNumberRows(parseInt(page));
                            }}
                          />
                        );
                      })()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
